module.exports = __webpack_public_path__ + "img/coinbankB12.78d358d1.jpg";